module.exports = __webpack_public_path__ + "img/apiecobooster-demoday-1.dcc09de1.jpg";